"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SmileyFace = void 0;
var _react = _interopRequireDefault(require("react"));
var _smiley = _interopRequireDefault(require("../../../../../../images/smiley.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SmileyFace = function SmileyFace(_ref) {
  var openEmojiPicker = _ref.openEmojiPicker;
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: openEmojiPicker,
    className: "emoji-button"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _smiley.default,
    alt: "Add emoji"
  }));
};
exports.SmileyFace = SmileyFace;